/**
 * @file Complete user management panel with authentication and role management
 * @version 1.0.0
 * @since 2025-08-25
 */

import UserData from './UserData.js';
import UserRoleToggle from './UserRoleToggle.js';
import { useUser } from '../composables/user.js';

export default {
  name: 'UserPanel',

  components: {
    UserData,
    UserRoleToggle,
  },

  props: {
    showRoleToggle: {
      type: Boolean,
      default() {
        const user = useUser();
        return user.allowGroupRequests;
      },
    },
    inDropdown: {
      type: Boolean,
      default: false,
    },
  },

  template: `
    <div class="container-fluid">      
      <div class="row">
        <div class="col-12">
          <UserData />
        </div>
      </div>
      
      <hr class="my-4" v-if="showRoleToggle" />
      
      <div class="row" v-if="showRoleToggle">
        <div class="col-12">
          <h5>Role Management</h5>
          <p class="text-muted">Manage user roles and permissions</p>
          <UserRoleToggle />
        </div>
      </div>
    </div>
  `,

  setup(props) {
    const user = useUser();

    return {
      user,
      showRoleToggle: props.showRoleToggle,
    };
  },
};
